import styled, { css } from 'styled-components';

const Card = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  height: ${({ height }) => height || 'auto'};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }

  ${({ variant }) => {
    switch(variant) {
      case 'outline':
        return css`
          box-shadow: none;
          border: 1px solid rgba(0,0,0,0.1);
          
          &:hover {
            border-color: var(--primary);
          }
        `;
      case 'flat':
        return css`
          box-shadow: none;
          
          &:hover {
            box-shadow: none;
            transform: none;
          }
        `;
      default:
        return css`
          box-shadow: var(--shadow-md);
          
          &:hover {
            transform: translateY(-5px);
            box-shadow: var(--shadow-lg);
          }
        `;
    }
  }}
`;

export const CardImage = styled.div`
  width: 100%;
  height: ${({ height }) => height || '200px'};
  overflow: hidden;
  position: relative;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  ${Card}:hover & img {
    transform: scale(1.05);
  }
  
  .card-tag {
    position: absolute;
    top: 1rem;
    left: 1rem;
    background-color: var(--secondary);
    color: var(--white);
    padding: 0.5rem 1rem;
    border-radius: var(--border-radius-sm);
    font-weight: 600;
    font-size: 0.75rem;
    text-transform: uppercase;
    z-index: 1;
  }
`;

export const CardBody = styled.div`
  padding: 1.5rem;
  
  h3 {
    margin-bottom: 0.75rem;
    font-size: 1.25rem;
  }
  
  p {
    color: var(--gray);
    margin-bottom: 1rem;
  }
`;

export const CardFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default Card;